var audioCtx = null;
var audioBufferCache = {};

function getAudioContext() {
    if (!audioCtx) {
        var AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (AudioContextClass) {
            audioCtx = new AudioContextClass();
        }
    }
    if (audioCtx && audioCtx.state === 'suspended') {
        audioCtx.resume().catch(function(e) {});
    }
    return audioCtx;
}

function unlockiOSAudio() {
    var ctx = getAudioContext();
    if (ctx && ctx.state === 'suspended') {
        ctx.resume().catch(function(e) {});
    }
    if (typeof window !== 'undefined' && 'speechSynthesis' in window && window.speechSynthesis) {
        try {
            if (window.speechSynthesis.paused) {
                window.speechSynthesis.resume();
            }
            if (!window._speechPrimed) {
                var dummy = new SpeechSynthesisUtterance(' ');
                dummy.volume = 0.01;
                dummy.rate = 10;
                window.speechSynthesis.speak(dummy);
                window._speechPrimed = true;
            }
        } catch (e) {}
    }
}

// Global touch/click listeners to unlock WebAudio and SpeechSynthesis on iOS Safari/WebViews
if (typeof window !== 'undefined') {
    ['touchstart', 'touchend', 'click', 'pointerdown'].forEach(function(evt) {
        window.addEventListener(evt, unlockiOSAudio, { capture: true, passive: true });
    });
}

function normalizeAudioUrl(file) {
    if (!file || typeof file !== 'string') return file;
    var clean = file.replace(/^(\.\.\/)+/, '');
    if (!clean.startsWith('http') && !clean.startsWith('/')) {
        clean = '/' + clean;
    }
    return encodeURI(clean);
}

function loadWebAudioBuffer(url) {
    var ctx = getAudioContext();
    if (!ctx) return Promise.reject("No AudioContext");
    if (audioBufferCache[url]) {
        return Promise.resolve(audioBufferCache[url]);
    }
    return fetch(url)
        .then(function(response) {
            if (!response.ok) throw new Error("HTTP error " + response.status);
            return response.arrayBuffer();
        })
        .then(function(buffer) {
            return new Promise(function(resolve, reject) {
                ctx.decodeAudioData(buffer, function(decoded) {
                    audioBufferCache[url] = decoded;
                    resolve(decoded);
                }, function(err) {
                    reject(err);
                });
            });
        });
}

function playSound(file) {
    return new Promise(function (resolve, reject) {
        if (!file) {
            resolve(null);
            return;
        }
        var url = normalizeAudioUrl(file);
        var ctx = getAudioContext();

        // 1. Try Web Audio API (Best for iPhone/iOS Mobile Safari & WebViews)
        if (ctx) {
            if (ctx.state === 'suspended') {
                ctx.resume().catch(function() {});
            }
            loadWebAudioBuffer(url).then(function(buffer) {
                try {
                    var source = ctx.createBufferSource();
                    source.buffer = buffer;
                    var gainNode = ctx.createGain();
                    gainNode.gain.value = 0.9;
                    source.connect(gainNode);
                    gainNode.connect(ctx.destination);
                    source.start(0);
                    resolve(source);
                    return;
                } catch (e) {
                    console.log("WebAudio play buffer error:", e);
                    fallbackHtmlAudio(url, file, resolve);
                }
            }).catch(function(err) {
                console.log("WebAudio load error for " + url + ", using HTMLAudio fallback:", err);
                fallbackHtmlAudio(url, file, resolve);
            });
        } else {
            fallbackHtmlAudio(url, file, resolve);
        }
    });
}

function fallbackHtmlAudio(url, originalFile, resolve) {
    try {
        var sound = new Audio(url);
        sound.setAttribute('playsinline', 'true');
        sound.setAttribute('webkit-playsinline', 'true');
        sound.preload = 'auto';

        var playPromise = sound.play();
        if (playPromise !== undefined) {
            playPromise.then(function() {
                resolve(sound);
            }).catch(function(e) {
                console.log("HTMLAudio fallback play catch for " + url, e);
                resolve(null);
            });
        } else {
            resolve(sound);
        }
    } catch (err) {
        console.log("HTMLAudio fallback exception for " + originalFile, err);
        resolve(null);
    }
}

